import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, User, Lock, LogOut, ChevronDown } from 'lucide-react';
import LoginModal from '../Authentication/LoginModal';
import RegisterModal from '../Authentication/RegisterModal';
import RegisterModalNoCode from '../Authentication/RegisterModalNoCode';
import ProfileModal from '../Authentication/ProfileModal';
import UserAvatar from '../Authentication/UserAvatar';
import Logo from './Logo';
import { LoginModalContext } from '../../App';
const Header = ({
  isLoggedIn,
  user,
  onLogout
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isEventPage = location.pathname === '/g4-ge-diego-ivo';
  const {
    openLoginModal
  } = useContext(LoginModalContext);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const openProfileModal = (tab = 'profile') => {
    setActiveTab(tab);
    setIsProfileModalOpen(true);
    setShowProfileDropdown(false);
  };
  const handleLogout = async () => {
    setIsLoggingOut(true);
    // Add a small delay to show the animation before actual logout
    setTimeout(async () => {
      await onLogout();
      setShowProfileDropdown(false);
      setIsLoggingOut(false);
    }, 300);
  };
  return <header className={`sticky top-0 z-40 w-full ${isHomePage ? 'bg-transparent' : 'bg-white border-b border-gray-100'}`} data-id="element-693">
      <div className="container flex items-center justify-between h-[83.2px] px-4 mx-auto sm:px-6" data-id="element-694">
        <Link to="/" className="flex items-center" data-id="element-695">
          <Logo isHomePage={isHomePage} data-id="element-696" />
        </Link>

        {/* Desktop navigation */}
        <nav className="hidden md:flex items-center space-x-6" data-id="element-697">
          {isLoggedIn ? <div className="flex items-center space-x-4 relative" ref={dropdownRef} data-id="element-698">
              <button className={`flex items-center space-x-2 ${isHomePage ? 'text-gray-800 hover:text-[#1649ff]' : 'text-gray-800 hover:text-[#1649ff]'} transition-colors text-lg`} onClick={() => setShowProfileDropdown(!showProfileDropdown)} onMouseEnter={() => setShowProfileDropdown(true)} data-id="element-699">
                <UserAvatar user={user} data-id="element-700" />
                <span data-id="element-701">{user.name?.split(' ')[0] || 'Usuário'}</span>
                <ChevronDown size={18} data-id="element-702" />
              </button>

              {/* Profile dropdown menu */}
              {showProfileDropdown && <div className="absolute right-0 top-full mt-2 w-52 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200" data-id="element-703">
                  <button onClick={() => openProfileModal('profile')} className="flex items-center w-full px-4 py-2 text-base text-gray-700 hover:bg-gray-100" data-id="element-704">
                    <User size={18} className="mr-2" data-id="element-705" />
                    Editar Perfil
                  </button>
                  <button onClick={() => openProfileModal('security')} className="flex items-center w-full px-4 py-2 text-base text-gray-700 hover:bg-gray-100" data-id="element-706">
                    <Lock size={18} className="mr-2" data-id="element-707" />
                    Segurança
                  </button>
                  <div className="border-t border-gray-200 my-1" data-id="element-708"></div>
                  <button onClick={handleLogout} className={`flex items-center w-full px-4 py-2 text-base text-red-600 hover:bg-gray-100 transition-all ${isLoggingOut ? 'scale-95 bg-red-50' : ''}`} disabled={isLoggingOut} data-id="element-709">
                    <LogOut size={18} className={`mr-2 ${isLoggingOut ? 'animate-pulse' : ''}`} data-id="element-710" />
                    {isLoggingOut ? 'Saindo...' : 'Sair'}
                  </button>
                </div>}
            </div> : <>
              <button onClick={() => setIsLoginModalOpen(true)} className={`${isHomePage ? 'text-gray-800 hover:text-[#1649ff]' : 'text-gray-800 hover:text-[#1649ff]'} transition-colors text-lg`} data-id="element-711">
                Entrar
              </button>
              <button onClick={() => setIsRegisterModalOpen(true)} className="px-5 py-2.5 bg-[#1649ff] hover:bg-blue-700 text-white rounded-md transition-colors text-lg" data-id="element-712">
                Criar conta
              </button>
            </>}
        </nav>
      </div>

      {/* Modals */}
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} onRegisterClick={() => {
      setIsLoginModalOpen(false);
      setIsRegisterModalOpen(true);
    }} data-id="element-713" />

      {/* Render correct registration modal based on route */}
      {isEventPage ? <RegisterModalNoCode isOpen={isRegisterModalOpen} onClose={() => setIsRegisterModalOpen(false)} onLoginClick={() => {
      setIsRegisterModalOpen(false);
      setIsLoginModalOpen(true);
    }} data-id="element-714" /> : <RegisterModal isOpen={isRegisterModalOpen} onClose={() => setIsRegisterModalOpen(false)} onLoginClick={() => {
      setIsRegisterModalOpen(false);
      setIsLoginModalOpen(true);
    }} data-id="element-715" />}

      {isLoggedIn && <ProfileModal isOpen={isProfileModalOpen} onClose={() => setIsProfileModalOpen(false)} user={user} onLogout={onLogout} activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-716" />}
    </header>;
};
export default Header;